/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Social_Export_Credits_HintInputs */

const cs_social_export_credits_hint = /** @type {(inputs: Social_Export_Credits_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI popisky a publikace na Meta spotřebovávají kredity CRM.`)
};

const en_social_export_credits_hint = /** @type {(inputs: Social_Export_Credits_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI captions and Meta publish use CRM credits.`)
};

/**
* | output |
* | --- |
* | "AI captions and Meta publish use CRM credits." |
*
* @param {Social_Export_Credits_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const social_export_credits_hint = /** @type {((inputs?: Social_Export_Credits_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Social_Export_Credits_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_social_export_credits_hint(inputs)
	return cs_social_export_credits_hint(inputs)
});